import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets.app/images/onboarding/shrug-emoji.png'


const _hoisted_1 = { class: "onboarding-books__cover-section" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "onboarding-books__controls-wrapper" }
const _hoisted_4 = { class: "onboarding-books__controls" }

import { computed, onMounted } from 'vue'

import { QuestionnaireView } from '@/models/onboarding'
import type {
  BooksChoice,
  PersonalizedBooksPage,
} from '@/models/onboarding.types'
import {
  getOnboardingBooks,
  getOnboardingBooksSubtitle,
} from '@/models/onboarding.personalization'

import Layout from '../Layout.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'PersonalizedBooks',
  props: {
    view: {}
  },
  setup(__props: any) {

const props = __props

const page = computed(() => {
  return props.view.currentPage as PersonalizedBooksPage
})

const currentChoices = computed(() => {
  return props.view.currentChoice as BooksChoice
})

const books = computed(() => {
  return getOnboardingBooks(props.view.subjectInterestsYou)
})

const booksSubtitlePhrase = computed(() => {
  return getOnboardingBooksSubtitle(props.view.subjectInterestsYou)
})

const currentBook = computed(() => {
  return books.value[props.view.currentSubpageIndex] ?? ''
})

function nextBook(score: number): void {
  props.view.setCurrentChoice([
    ...currentChoices.value,
    { id: currentBook.value, score },
  ])

  const nextBookExists = props.view.nextSubpage()

  if (!nextBookExists) {
    props.view.goNextPage()
  }
}

function preloadBookCovers(): void {
  for (const slug of books.value) {
    const image = document.createElement('img')
    image.src = props.view.getBookCover(slug)
  }
}

onMounted(() => {
  props.view.setCurrentChoice([])
  preloadBookCovers()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, {
    class: "onboarding-books",
    title: page.value.title,
    subtitle: `To help you ${booksSubtitlePhrase.value} ...`,
    reverseTitleSubtitle: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("div", {
              key: currentBook.value,
              class: "onboarding-books__cover-wrapper"
            }, [
              _cache[3] || (_cache[3] = _createElementVNode("svg", {
                class: "onboarding-books__cover-bg-svg",
                width: "310",
                height: "240",
                viewBox: "0 0 310 240",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                "aria-hidden": "true"
              }, [
                _createElementVNode("path", {
                  opacity: "0.15",
                  d: "M0.120931 34.5258C-0.955975 25.7551 5.28107 17.772 14.0518 16.6951L149.038 0.120879C157.809 -0.956028 165.792 5.28102 166.869 14.0517L190.268 204.621C191.345 213.391 185.107 221.374 176.337 222.451L41.3505 239.025C32.5798 240.102 24.5967 233.865 23.5198 225.095L0.120931 34.5258Z",
                  fill: "#FFC940"
                }),
                _createElementVNode("rect", {
                  opacity: "0.15",
                  width: "168",
                  height: "224",
                  rx: "16",
                  transform: "matrix(0.992546 0.121869 0.121869 -0.992546 117.171 220.502)",
                  fill: "#FFC940"
                })
              ], -1)),
              _createElementVNode("img", {
                src: __props.view.getBookCover(currentBook.value),
                alt: currentBook.value,
                width: "223",
                height: "298",
                class: "onboarding-books__cover"
              }, null, 8, _hoisted_2)
            ]))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "onboarding-books__button onboarding-books__button--negative",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (nextBook(-1)), ["prevent"]))
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("span", { class: "iconfont idislike" }, null, -1)
          ]))]),
          _createElementVNode("button", {
            class: "onboarding-books__button onboarding-books__button--neutral",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (nextBook(0)), ["prevent"]))
          }, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: ""
            }, null, -1)
          ]))]),
          _createElementVNode("button", {
            class: "onboarding-books__button onboarding-books__button--positive",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (nextBook(1)), ["prevent"]))
          }, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("span", { class: "iconfont ilike" }, null, -1)
          ]))])
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "onboarding-books__controls-labels" }, [
          _createElementVNode("p", { class: "onboarding-books__controls-label" }, "Not interested"),
          _createElementVNode("p", { class: "onboarding-books__controls-label" }, "Interested")
        ], -1))
      ])
    ]),
    _: 1
  }, 8, ["title", "subtitle"]))
}
}

})